/**
 * Utility functions for generating and working with URL slugs
 */

/**
 * Convert a string to a URL-friendly slug
 * @param {string} text - The text to convert to a slug
 * @returns {string} - URL-friendly slug
 */
export const createSlug = (text) => {
  if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')        // Replace spaces with hyphens
    .replace(/[^\w-]+/g, '') // Remove all non-word chars (hyphen allowed unescaped at end of class)
    .replace(/-+/g, '-') // Collapse hyphen runs (after spaces already became hyphens)
    .replace(/^-+/, '')          // Trim hyphens from start
    .replace(/-+$/, '');         // Trim hyphens from end
};

/**
 * Generate a slug from an excursion name
 * @param {string} name - The excursion name
 * @returns {string} - URL-friendly slug
 */
export const getExcursionSlug = (name) => {
  return createSlug(name);
};

export default createSlug;

